"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const EventAvailable = _ref => {
  let {
    title = 'Event Available',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.313 25.969v-14.625h-18.625v14.625h18.625zM25.313 4.656q1.063 0 1.875 0.813t0.813 1.875v18.625q0 1.094-0.797 1.891t-1.891 0.797h-18.625q-1.125 0-1.906-0.797t-0.781-1.891v-18.625q0-1.063 0.781-1.875t1.906-0.813h1.313v-2.688h2.688v2.688h10.625v-2.688h2.688v2.688h1.313zM22.063 15.406l-7.938 7.938-4.25-4.25 1.438-1.438 2.813 2.813 6.5-6.5z"
  }));
};
var _default = exports.default = (0, _ikon.default)(EventAvailable);
EventAvailable.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EventAvailable",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Event Available'",
        "computed": false
      },
      "required": false
    }
  }
};